import type { IContextProviderService, IContextProviderServiceConfig } from './contextProviderService'
import type { ICompChangeStore } from '../types'

export const createContextProviderService = (
	config: IContextProviderServiceConfig,
	store?: ICompChangeStore
): IContextProviderService => {
	return {
		getAttachedContexts: (compId: string) => {
			return config.compIdToContextsMap[compId] || []
		},
		subscribeToContextChanges: (compId: string, callback: () => void) => {
			if (!store) {
				return () => {}
			}
			return store.subscribeToChanges(compId, callback)
		},
	}
}
